export default __webpack_public_path__ + "static/media/no-data-7724.6bef20ac.svg";